"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lessons = require("../../utils/lessons.util");
var _CourseContentDisclaimer = _interopRequireDefault(require("./partials/CourseContentDisclaimer"));
require("./LessonContent.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var LessonContentDesktop = function LessonContentDesktop(_ref) {
  var selectedLesson = _ref.selectedLesson,
    lessonContent = _ref.lessonContent;
  var title = selectedLesson.title,
    ordinal = selectedLesson.ordinal;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "lesson-content",
    className: "card flex-grow bg-white px-[56px] py-[64px] mb-[44px] max-w-[928px]"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "tw-subtitle-lg-regular mb-[30px]"
  }, (0, _lessons.getLessonTitleWithOrdinal)(title, ordinal)), /*#__PURE__*/_react.default.createElement("span", {
    className: "lesson-content"
  }, lessonContent), /*#__PURE__*/_react.default.createElement(_CourseContentDisclaimer.default, null));
};
var _default = LessonContentDesktop;
exports.default = _default;